module.exports = __webpack_public_path__ + "static/media/4_l_stul_10.47_84.63.bffd0156.png";